import React, { useState, useEffect } from "react";
import "./ImagePreview.css";
import PropTypes from "prop-types";

const ImagePreview = ({ src, alt, className = "", ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      closeModal();
    }
  };

  return (
    <div>
      <img
        src={src}
        alt={alt}
        // width="60"
        className={`thumbnail ${className}`}
        onClick={openModal}
        aria-label="Click to preview full image"
        role="button"
        {...props}
      />

      {isOpen && (
        <div
          className="modal"
          role="dialog"
          aria-modal="true"
          onClick={handleOutsideClick}
        >
          <button
            className="modal-close"
            onClick={closeModal}
            aria-label="Close Preview"
          >
            &times;
          </button>
          <img
            src={src}
            alt="Enlarged Preview"
            className="modal-content"
            style={{ height: "auto", width: "auto" }}
          />
        </div>
      )}
    </div>
  );
};

export default ImagePreview;

ImagePreview.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
};
